export default "__VITE_PUBLIC_ASSET__a6d5d136__"